import { automationsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { UpdateStageJson } from '../types';

export const useUpdateStage = () =>
  useMutation<unknown, unknown, UpdateStageJson>((updateStage) =>
    automationsRepo.updateStage(updateStage),
  );
